import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";
import { useLang } from "../contexts/LanguageContext";

export default function FAQ() {
  const { t } = useLang();
  return (
    <section className="section-pad bg-cb-paper">
      <div className="container-cb grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-4">
          <div className="overline mb-4 flex items-center gap-3"><span className="gold-divider" /> {t.faq.overline}</div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-semibold text-cb-primary">{t.faq.title}</h2>
        </div>
        <div className="lg:col-span-8">
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {t.faq.items.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} data-testid={`faq-item-${i}`}>
                <AccordionTrigger className="text-start text-cb-primary text-base lg:text-lg font-medium" style={{ fontFamily: "Outfit" }}>
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-cb-secondary text-base leading-relaxed">{f.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
